import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withTranslate from '../../containers/widgets/withTranslate';
import css from './Card.css';

const Card = ({
    dataTestId = '',
    header = null,
    children = null,
    contentClassName = '',
    cardClassName = '',
    style = {},
}) => {
    return (
        <div data-testid={dataTestId} className={classNames(css.card, cardClassName)} style={style}>
            <div className={css.header}>{header}</div>
            <div className={css.divider} />
            <div className={classNames(css.content, contentClassName)}>{children}</div>
        </div>
    );
};

Card.propTypes = {
    dataTestId: PropTypes.string,
    header: PropTypes.node,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    contentClassName: PropTypes.string,
    cardClassName: PropTypes.string,
    style: PropTypes.objectOf(PropTypes.string),
};

export default withTranslate(Card);
